import axios from "../../../axios";

export default {
  namespaced: true,
  state: {
    step: 1,
    language: {},
    products: [],
    payments: [],
    shippings: [],
    freeShippingLimit: undefined,
    cartData: {
      payment: null,
      shipping: null,
      hasFreeShipping: false,
      customer: {},
      products: [],
    },
  },
  getters: {
    getStep: (state) => state.step,
    getProducts: (state) => state.products,
    getCartData: (state) => state.cartData,
    getPayments: (state) => state.payments,
    getShippings: (state) => state.shippings,
    getLanguage: (state) => state.language,
    getFreeShippingLimit: (state) => state.freeShippingLimit,
    getHasFreeShipping: (state) => state.cartData.hasFreeShipping,
  },
  mutations: {
    INCREMENT_STEP: (state) => state.step++,
    DECREMENT_STEP: (state) => state.step--,
    SET_LANGUAGE(state, payload) {
      state.language = payload;
    },
    SET_STEP(state, payload) {
      state.step = payload;
    },
    SET_PRODUCTS(state, payload) {
      state.products = payload;
    },
    SET_PAYMENTS(state, payload) {
      state.payments = payload;
    },
    SET_SHIPPINGS(state, payload) {
      state.shippings = payload;
    },
    SET_CART_DATA(state, payload) {
      state.cartData = {
        // default
        payment: payload.hasOwnProperty("payment")
          ? payload.payment
          : state.cartData.payment,
        shipping: payload.hasOwnProperty("shipping")
          ? payload.shipping
          : state.cartData.shipping,
        products: payload.hasOwnProperty("products")
          ? payload.products
          : state.cartData.products,
        customer: payload.hasOwnProperty("customer")
          ? payload.customer
          : state.cartData.customer,
        hasFreeShipping: payload.hasOwnProperty("hasFreeShipping")
          ? payload.hasFreeShipping
          : state.cartData.hasFreeShipping,
      };
    },
    SET_FREE_SHIPPING_LIMIT(state, value) {
      if (value) {
        state.freeShippingLimit = Number(value);
      }
    },
    SET_HAS_FREE_SHIPPING(state, status) {
      state.cartData.hasFreeShipping = !!status;
    },
    INCREMENT_PRODUCT_QTY(state, item) {
      ++item.qty;
    },
    DECREMENT_PRODUCT_QTY(state, item) {
      if (item.qty > 1) {
        --item.qty;
      }
    },
    ADD_PRODUCT_TO_CART(state, item) {
      state.cartData.products.push(item);
    },
    UPDATE_PRODUCT_IN_CART(state, item) {
      state.cartData.products[item.cartIndex] = item;
    },
    REMOVE_PRODUCT_FROM_CART(state, item) {
      state.cartData.products = state.cartData.products.filter((cartItem) => {
        return cartItem != item;
      });
    },
  },
  actions: {
    GET_PAYMENTS() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/payment`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    GET_SHIPPINGS() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/shipping`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    CALCULATE_PRICE({ state }, product) {
      let attributeValues = [];

      for (const key in product.attribute_values) {
        attributeValues.push(product.attribute_values[key].id);
      }

      const data = {
        id: product.id,
        attribute_values: attributeValues,
      };

      return new Promise((resolve, reject) => {
        axios
          .post(`/api/product/variant`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
